//index.js
export const INIT_VIEWPORT = 'INIT_VIEWPORT';
export const SET_PIXEL_RATIO = 'SET_PIXEL_RATIO';
export const SET_SCENE_ENV = 'SET_SCENE_ENV';
export const UPLOAD_MANNEQUIN = 'UPLOAD_MANNEQUIN';
export const RENDER = 'RENDER';
export const SET_SCENE_BACKGROUND = 'SET_SCENE_BACKGROUND';
export const SET_TITLE = 'SET_TITLE';
export const SET_INIT_COMPLETED = 'SET_INIT_COMPLETED';


//modules/mannequin.js
export const SET_POSER_INSTANCE = 'SET_POSER_INSTANCE';
export const SET_MANNEQUIN_COLOR = 'SET_MANNEQUIN_COLOR';
export const UPDATE_POSER_ROTATION = 'UPDATE_POSER_ROTATION';
export const INIT_MANNEQUINS = 'INIT_MANNEQUINS';
export const SET_MANNEQUIN = 'SET_MANNEQUIN';
export const REMOVE_MANNEQUIN = 'REMOVE_MANNEQUIN';

//modules/camera.js
export const INIT_CAMERA = 'INIT_CAMERA';
// export const MOVE_DOLLY = 'MOVE_DOLLY';

//modules/fabrics.js
export const APPLY_FABRIC = 'APPLY_FABRIC';
export const UPLOAD_MATERIAL = 'UPLOAD_MATERIAL';
export const INIT_FABRICS = 'INIT_FABRICS';

//modules/textures.js
export const SET_SELECTED_COLOR = 'SET_SELECTED_COLOR';
export const SET_SELECTED_TEXTURE = 'SET_SELECTED_TEXTURE';
export const INIT_TEXTURES = 'INIT_TEXTURES';
export const RESET_TEXTURES = 'RESET_TEXTURES';


//module/clothes.js
export const SET_SELECTED_DRESS = 'SET_SELECTED_DRESS';
export const SET_SELECTED_MESH = 'SET_SELECTED_MESH';
export const LOAD_DRESS = 'LOAD_DRESS';
export const PUSH_WORN_DRESS = 'PUSH_WORN_DRESS';
export const UNWEAR_DRESS = 'UNWEAR_DRESS';
export const SET_MESH_COLOR = 'SET_MESH_COLOR';
export const SET_CLOTHES = 'SET_CLOTHES';

//module/snapshots.js
export const SET_SNAPSHOT = 'SET_SNAPSHOT';
export const ADD_SNAPSHOT = 'ADD_SNAPSHOT';
export const SET_SNAPSHOTS = 'SET_SNAPSHOTS';
export const REMOVE_SNAPSHOT = 'REMOVE_SNAPSHOT';

//module/shoes.js
export const INIT_SHOES = 'INIT_SHOES';
export const SET_SELECTED_SHOES = 'SET_SELECTED_SHOES';
export const RESET_SELECTED_SHOES = 'RESET_SELECTED_SHOES';